import axios from 'axios';

export async function apiGet(path) {
    const authToken = localStorage.getItem("token");
    console.log('authToken',authToken);
    if(authToken==null)
    {
        window.location.replace("/Login")
    }
    // const authToken='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MiwiY29tcGFueV9pZCI6MSwiZW1wbG95ZWVfaWQiOiJFTVAxMjM0MyIsImRlc2lnbmF0aW9uX2lkIjoxLCJmaXJzdF9uYW1lIjoiWWF0ZXJuZHJhIiwibGFzdF9uYW1lIjoiVGl3YXJpIiwicGFzc3dvcmQiOiIkMmIkMTAkRGQ3Lm56S3pFY3A5di5hOXlxdUl5dTZDa3o1N1QuVzcyYlpWL1ZMeHFTaFI5L3p1NUlmbXkiLCJwaG9uZV9ubyI6Ijg5NzYzOTU4NTAiLCJlbWFpbCI6InlhdGVuZHJhLnRpd2FyaUB5cGF5Y2FyZC5jb20iLCJhZGRyZXNzIjoiMTIzLCBFbG0gU3RyZWV0LCBEb3dudG93biIsImxvY2F0aW9uX2lkIjoyLCJzdGF0ZV9pZCI6MiwiY2l0eV9pZCI6MSwicGluY29kZSI6MjAxMzAxLCJpc19hY3RpdmUiOnRydWUsImNyZWF0ZWRBdCI6IjIwMjUtMDEtMjFUMTA6MzM6NDMuNzk2WiIsInVwZGF0ZWRBdCI6IjIwMjUtMDEtMjFUMTA6MzM6NDMuNzk2WiIsImlhdCI6MTczNzQzODM3MywiZXhwIjoxNzM3NTI0NzczfQ.Sxmjcmm4khwqdhL6EVMS-Rij6-qV4YIgFWjK94pqQ78'

    const config = {

        headers: {
            Authorization: authToken ? `Bearer ${authToken}` : null,
        },
    };
    return axios.get(path, config);
}

export async function apiPost(path, data) {
    // const authToken ='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MiwiY29tcGFueV9pZCI6MSwiZW1wbG95ZWVfaWQiOiJFTVAxMjM0MyIsImRlc2lnbmF0aW9uX2lkIjoxLCJmaXJzdF9uYW1lIjoiWWF0ZXJuZHJhIiwibGFzdF9uYW1lIjoiVGl3YXJpIiwicGFzc3dvcmQiOiIkMmIkMTAkRGQ3Lm56S3pFY3A5di5hOXlxdUl5dTZDa3o1N1QuVzcyYlpWL1ZMeHFTaFI5L3p1NUlmbXkiLCJwaG9uZV9ubyI6Ijg5NzYzOTU4NTAiLCJlbWFpbCI6InlhdGVuZHJhLnRpd2FyaUB5cGF5Y2FyZC5jb20iLCJhZGRyZXNzIjoiMTIzLCBFbG0gU3RyZWV0LCBEb3dudG93biIsImxvY2F0aW9uX2lkIjoyLCJzdGF0ZV9pZCI6MiwiY2l0eV9pZCI6MSwicGluY29kZSI6MjAxMzAxLCJpc19hY3RpdmUiOnRydWUsImNyZWF0ZWRBdCI6IjIwMjUtMDEtMjFUMTA6MzM6NDMuNzk2WiIsInVwZGF0ZWRBdCI6IjIwMjUtMDEtMjFUMTA6MzM6NDMuNzk2WiIsImlhdCI6MTczNzQ1NTg3MiwiZXhwIjoxNzM3NTQyMjcyfQ.UbedVbXzEIxlflgPec2JUIq1sfeLH6tA_dGCXtiF1YI';
    const authToken = localStorage.getItem("token");
    //  if (!authToken) {
    //     window.location.replace("/Login");
    //     return;
    // }

    // console.log('authToken', authToken);
    const config = {
        headers: {
            Authorization: authToken ? `Bearer ${authToken}` : null,
            'Content-Type': 'application/json',
        },
    };
    console.log(data, "owasdfgiuyreiuyresdfgjiuytrsjhg")
    return axios.post(path, data, config);
}

export async function apiPost1(path, data) {
    // const authToken ='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MiwiY29tcGFueV9pZCI6MSwiZW1wbG95ZWVfaWQiOiJFTVAxMjM0MyIsImRlc2lnbmF0aW9uX2lkIjoxLCJmaXJzdF9uYW1lIjoiWWF0ZXJuZHJhIiwibGFzdF9uYW1lIjoiVGl3YXJpIiwicGFzc3dvcmQiOiIkMmIkMTAkRGQ3Lm56S3pFY3A5di5hOXlxdUl5dTZDa3o1N1QuVzcyYlpWL1ZMeHFTaFI5L3p1NUlmbXkiLCJwaG9uZV9ubyI6Ijg5NzYzOTU4NTAiLCJlbWFpbCI6InlhdGVuZHJhLnRpd2FyaUB5cGF5Y2FyZC5jb20iLCJhZGRyZXNzIjoiMTIzLCBFbG0gU3RyZWV0LCBEb3dudG93biIsImxvY2F0aW9uX2lkIjoyLCJzdGF0ZV9pZCI6MiwiY2l0eV9pZCI6MSwicGluY29kZSI6MjAxMzAxLCJpc19hY3RpdmUiOnRydWUsImNyZWF0ZWRBdCI6IjIwMjUtMDEtMjFUMTA6MzM6NDMuNzk2WiIsInVwZGF0ZWRBdCI6IjIwMjUtMDEtMjFUMTA6MzM6NDMuNzk2WiIsImlhdCI6MTczNzQ1NTg3MiwiZXhwIjoxNzM3NTQyMjcyfQ.UbedVbXzEIxlflgPec2JUIq1sfeLH6tA_dGCXtiF1YI';
    const authToken = localStorage.getItem("token");
  // console.log('authToken', authToken);
    const config = {
        headers: {
            Authorization: authToken ? `Bearer ${authToken}` : null,
            'Content-Type': 'multipart/form-data;',
        },
    };

    return axios.post(path, data, config);
}


export async function apiPut(path, data) {
    const authToken = localStorage.getItem("token");

    const config = {
        headers: {
            Authorization: authToken ? `Bearer ${authToken}` : null,
            'Content-Type': 'application/json',
        },
    };

    try {
        const response = await axios.put(path, data, config);
        console.log("axios error", path, data, config)
        return response;  // Return data or full response as needed
    } catch (error) {
        console.error('Error making PUT request:', error);
        throw error;
    }
}

export async function apiPut1(path, data) {
    const authToken = localStorage.getItem("token");

    const config = {
        headers: {
            Authorization: authToken ? `Bearer ${authToken}` : null,
            'Content-Type': 'multipart/form-data;',
        },
    };

    try {
        const response = await axios.put(path, data, config);
        console.log("axios error", path, data, config)
        return response;  // Return data or full response as needed
    } catch (error) {
        console.error('Error making PUT request:', error);
        throw error;
    }
}

const instance = axios.create();

export default instance;